import { FC, ReactNode, useEffect, useState } from "react";
import styles from "./index.module.scss";
import Diamonds from "../diamonds";
import UserPassport from "../user-passport";
import { useNavigate } from "react-router-dom";
import { getUserInfo, getXps } from "../../api";
import { UserInfo, Xps } from "../../types";
import { updateSdkSetting } from "../../utils";
import JoinCommunity from "../join-community";
import { LOGIN_SUCCESS } from "../../constants";
import JoinSeason from "../join-season";
import dayjs, { Dayjs } from "dayjs";

type ActiveKey =
  | "course"
  | "blog"
  | "old-exam"
  | "problemset"
  | "exam"
  | "online-editor"
  | "promotion"
  | "chatgpt"
  | "vip"
  | "app-download"
  | "qwerty"
  | "undefined";

type Menu = {
  key: ActiveKey;
  title: ReactNode | string;
  path: string;
};

interface NavigatorProps {
  activeKey?: ActiveKey;
}

const Navigator: FC<NavigatorProps> = ({ activeKey = "undefined" }) => {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);
  const [xps, setXps] = useState<Xps | null>(null);

  const [isVip, setIsVip] = useState(true);

  useEffect(() => {
    if (!userInfo) {
      return;
    }
    if (!userInfo.vip_infos?.length) {
      setIsVip(false);
      return;
    }
    let latest = userInfo.vip_infos.reduce<Dayjs>((current, item) => {
      if (dayjs(item.end_day).isAfter(current)) {
        return dayjs(item.end_day);
      }
      return current;
    }, dayjs().subtract(1, "minutes"));
    setIsVip(latest.isAfter(new Date()));
  }, [userInfo]);

  const menus: Menu[] = [
    {
      key: "course",
      title: "课程",
      path: "/course/list",
    },
    {
      key: "problemset",
      title: "题库",
      path: "/problemset/all/1",
    },
    {
      key: "blog",
      title: "专栏",
      path: "/blog/list",
    },
    {
      key: "online-editor",
      title: "在线编程",
      path: "/playground",
    },
    {
      key: "exam",
      title: "二级刷题",
      path: "/exam/list",
    },
    // {
    //   key: "qwerty",
    //   title: "肌肉背单词",
    //   path: "/qwerty",
    // },
    {
      key: "app-download",
      title: "APP下载",
      path: "/app-download",
    },
    {
      key: "vip",
      title: <div className={styles.vipTitle}>VIP会员</div>,
      path: "/vip",
    },
  ];

  const goto = (path: string) => {
    if (!path) {
      alert("未定义跳转");
      return;
    }
    if (path.includes("http")) {
      window.open(path, "_blank");
      return;
    }
    navigate(path);
  };

  useEffect(() => {
    const init = () => {
      getUserInfo().then((userInfo) => {
        setUserInfo(userInfo);
        updateSdkSetting(userInfo);
      });
      getXps().then((xps) => {
        setXps(xps);
      });
    };

    init();

    window.addEventListener(LOGIN_SUCCESS, init);
    return () => {
      window.removeEventListener(LOGIN_SUCCESS, init);
    };
  }, []);

  const handleBannerClick = () => {
    navigate("/vip");
  };

  console.log(isVip);

  return (
    <>
      {!isVip && (
        <div className={styles.banner} onClick={handleBannerClick}>
          <span className={styles.tag}>【开学季特惠】</span>
          <span className={styles.text}>
            开通会员，买1年送1年，畅学22+精品课程，1 v 1 答疑，赠送超值题库。
          </span>
        </div>
      )}
      <div className={styles.navigator}>
        <div className={styles.left}>
          <div className={styles.brand} onClick={() => goto("/")}>
            <div className={styles.logo} />
          </div>
        </div>
        <div className={styles.center}>
          <ul className={styles.menus}>
            {menus.map(({ key, title, path }) => (
              <li
                className={key === activeKey ? styles.active : ""}
                onClick={() => goto(path)}
                key={key}
              >
                {title}
              </li>
            ))}
          </ul>
        </div>
        <div className={styles.right}>
          {!!userInfo && (
            <div className={styles.extra}>
              {!!userInfo?.seasons?.length ? <JoinSeason /> : <JoinCommunity />}
              {userInfo.is_login && <Diamonds value={xps?.bit || 0} />}
              <UserPassport userInfo={userInfo} />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Navigator;
